import React from 'react';
import {
  required,
  List,
  Datagrid,
  Create,
  SimpleForm,
  TextField,
  ReferenceInput,
  AutocompleteInput,
  ReferenceField,
  Filter,
  TextInput,
  FunctionField,
  SelectInput,
} from 'react-admin';
import RejectPurchaseOrderBtn from '../skills/RejectPurchaseOrderBtn';

const OrderFilter = (props) => (
  <Filter {...props}>
    <TextInput label="User Id" source="userId" />
    <TextInput label="PhoneNumber" source="phoneNumber" alwaysOn />
  </Filter>
);

const renderRejectButton = (status, id) => {
  if (status !== 'APPROVED') {
    return '';
  }

  return <RejectPurchaseOrderBtn id={id} />;
}

export const PurchaseOrderListForQuizBundle = props => (
  <List title="Хэлний шалгалтын захиалгууд" {...props} filters={<OrderFilter/>}>
    <Datagrid optimized>
      <TextField label="ID" source="id" />
      <ReferenceField label="Хөтөлбөр" source="items.0.productId" reference="lt/quizBundles">
        <TextField label="Нэр" source="title" />
      </ReferenceField>
      <ReferenceField source="userId" reference="users" label="Имэйл">
        <TextField source="email" />
      </ReferenceField>
      <TextField label="Төлбөр" source="items.0.amount" />
      <TextField label="Статус" source="status" />
      <FunctionField label="" render={record => renderRejectButton(record.status, record.id)} />
    </Datagrid>
  </List>
);

export const PurchaseOrderCreateForQuizBundle = props => (
  <Create title="Хэлний шалгалтын захиалга үүсгэх" {...props}>
    <SimpleForm>
      <ReferenceInput label="Хэрэглэгч" source="userId" reference="users">
        <AutocompleteInput source="userId" optionText="email" validate={[required()]} />
      </ReferenceInput>
      <ReferenceInput
        label="Quiz Bundle"
        source="quizBundleId"
        reference="lt/quizBundles"
      >
        <SelectInput source="quizBundleId" optionText="title" validate={[required()]} />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);
